<template>
  <v2-table
    url="/api/v2/dialog?append=dialog_id&include=customer,fake&paginate"
    :headers="headers"
  >
    <template slot="filter">
      <basic-filter titel="ID" name="dialog_id"></basic-filter>
      <basic-filter
        titel="Partner A ID"
        name="fake_and_customer_profile_id"
      ></basic-filter>
      <basic-filter
        titel="Partner B ID"
        name="fake_and_customer_profile_id2"
      ></basic-filter>
      <basic-filter
        titel="Partner A Name"
        name="fake_and_customer_profile_name"
      ></basic-filter>
      <basic-filter
        titel="Partner B Name"
        name="fake_and_customer_profile_name2"
      ></basic-filter>
      <date-range-filter name="last_message_between"></date-range-filter>
    </template>
    <tr slot="row" slot-scope="{ item }">
      <td>
        <router-link :to="`/dialogkontrolle/${item.dialog_id}`">{{
          item.dialog_id
        }}</router-link>
      </td>
      <profile-cell
        :profile="item.customer"
        :message-count="item.customer_message_count"
      ></profile-cell>
      <profile-cell
        :profile="item.fake"
        :message-count="item.fake_message_count"
      ></profile-cell>
      <td v-html="getDateTimeHtml(item.last_message_at)"></td>
    </tr>
  </v2-table>
</template>

<script lang="babel">
import ProfileCell from "@/components/profile/Cell.vue";
import BasicFilter from "@/components/v2filter/BasicFilter.vue";
import DateRangeFilter from "@/components/v2filter/DateRangeFilter.vue";
import { getDateTimeHtml } from "@/js/date";

export default {
  components: {
    ProfileCell,
    BasicFilter,
    DateRangeFilter
  },
  data() {
    return {
      // id: "",
      range: null,
      filter: "",
      getDateTimeHtml,
      headers: [
        {
          text: 'ID',
        },
        {
          text: 'Benutzer A',
        },
        {
          text: 'Benutzer B',
        },
        {
          text: 'Letzte Nachricht',
        }
      ]
    };
  }
};
</script>
